import Icon from './Icon';

// Large-title page scaffold for phone screens. Title on the left, an
// optional side slot (progress, a count, a button) on the right, an
// optional search box under it. Desktop gets the same header at a
// smaller scale via the .m-title rules in mobile.css.
export default function MobilePage({ title, subtitle, side, search, onSearch, searchPlaceholder = 'Search', children, style }) {
  return (
    <div className="m-page" style={style}>
      <div className="m-page-head">
        <div style={{ minWidth: 0 }}>
          <h1 className="m-title">{title}</h1>
          {subtitle && <p className="m-sub">{subtitle}</p>}
        </div>
        {side && <div className="m-head-side">{side}</div>}
      </div>
      {onSearch && (
        <label className="m-search">
          <Icon name="search" size={20} color="#64748b" />
          <input type="search" value={search || ''} onChange={e => onSearch(e.target.value)}
            placeholder={searchPlaceholder} autoComplete="off" autoCorrect="off" autoCapitalize="none" />
          {search && (
            <button type="button" onClick={() => onSearch('')} aria-label="Clear"
              style={{ border: 0, background: 'none', padding: 4, cursor: 'pointer', color: '#94a3b8', display: 'flex' }}>
              <Icon name="x" size={18} />
            </button>
          )}
        </label>
      )}
      {children}
    </div>
  );
}
